/**
 * Rutas del frontend.
 *
 * Las rutas se escriben en ingles, igual que el resto del codigo y que la base
 * de datos; el espanol queda para los textos que ve el usuario (ADR-022). Antes
 * eran mixtas —`/obras`, `/panel`— y obligaban a traducir mentalmente entre la
 * URL, el endpoint y el nombre del componente.
 *
 * Cada ruta lleva delante el prefijo de su sistema. El shell esta preparado
 * para alojar mas de una aplicacion, y sin prefijo dos sistemas se pelearian
 * por nombres genericos como `/users` o `/dashboard` en cuanto llegue el
 * segundo.
 *
 * Este archivo es la unica fuente de las rutas: el router, el catalogo de
 * navegacion y cualquier redireccion leen de aqui, nunca de una cadena suelta.
 *
 * Las rutas con parametro se declaran con su patron (`:id`) y se resuelven con
 * `routeTo`, para que ningun componente arme la URL concatenando cadenas.
 *
 * Todo lo que se construya mientras el trabajo siga en el almacen cuelga de
 * `warehouse`, usuarios y auditoria incluidos. Cuando exista una segunda
 * aplicacion se decidira si algo sube a un prefijo compartido; sacarlo antes
 * seria repartir rutas entre sistemas que todavia no existen.
 */
export const ROUTES = {
  login: '/login',
  forbidden: '/forbidden',

  warehouse: {
    root: '/warehouse',
    dashboard: '/warehouse/dashboard',
    products: '/warehouse/products',
    productDetail: '/warehouse/products/:id',
    productAttributes: '/warehouse/product-attributes',
    assets: '/warehouse/assets',
    inventoryEntries: '/warehouse/inventory-entries',
    inventoryEntryDetail: '/warehouse/inventory-entries/:id',
    stock: '/warehouse/stock',
    lowStock: '/warehouse/low-stock',
    kardex: '/warehouse/kardex',
    surpluses: '/warehouse/surpluses',
    orders: '/warehouse/orders',
    orderNew: '/warehouse/orders/new',
    orderDetail: '/warehouse/orders/:id',
    orderEdit: '/warehouse/orders/:id/edit',
    incidents: '/warehouse/incidents',
    emails: '/warehouse/emails',
    projectReport: '/warehouse/project-report',
    projects: '/warehouse/projects',
    contacts: '/warehouse/contacts',
    locations: '/warehouse/locations',
    categories: '/warehouse/categories',
    unitsOfMeasure: '/warehouse/units-of-measure',
    suppliers: '/warehouse/suppliers',
    users: '/warehouse/users',
    auditLogs: '/warehouse/audit-logs',
  },

  driver: {
    root: '/driver',
    orders: '/driver/orders',
    orderDetail: '/driver/orders/:id',
  },
} as const;

/**
 * Sustituye los parametros de un patron de ruta.
 *
 * `routeTo(ROUTES.warehouse.productDetail, { id })` devuelve
 * `/warehouse/products/12`. Existe para que la forma de la URL siga viviendo
 * solo en este archivo tambien cuando la ruta lleva parametros.
 */
export function routeTo(pattern: string, params: Record<string, string>): string {
  return Object.entries(params).reduce(
    (path, [key, value]) => path.replace(`:${key}`, encodeURIComponent(value)),
    pattern,
  );
}
